import analyticsGA4Functions from 'nh-vue-layout/config/analyticsGA4'

class EventsGA4 {
  constructor(ctx) {
    this.ctx = ctx
  }

  getTrackData() {
    return [
      {
        event: ''
      }
    ]
  }

  trackEvent(type, payload) {
    const events = {
      ...analyticsGA4Functions.globalFunctions,
      experience_cancellation(data) {
        const eventList = {
          event: 'experience cancellation',
          experience_category: data.payload.liveLocal?.categoryName,
          experience_confirmation_id: data.payload.liveLocal?.itemReservationNumber,
          experience_date: data.ctx.$moment(data.payload.liveLocal?.itemDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          experience_id: data.payload.liveLocal?.offerContentId,
          experience_value: data.payload.liveLocal?.price?.totalPrice,
          hotel_brand: data.payload.hotel?.brand
            ? data.payload.hotel?.brand
            : data.payload.liveLocal?.hostHotel?.brandName
            ? data.payload.liveLocal.hostHotel.brandName
            : '',
          hotel_name: data.payload.hotel?.nameHotel
            ? data.payload.hotel.nameHotel
            : data.payload.liveLocal?.hostHotel?.hotelName
            ? data.payload.liveLocal.hostHotel.hotelName
            : '',
          nhScreen: data.payload.content.meta?.websection,
          language_code: data.ctx.i18n.locale ? data.ctx.i18n.locale.toUpperCase() : '',
          page_business_type: 'B2C',
          page_lang: data.payload.mainConfig?.analyticLang,
          page_section: data.payload.content.meta?.websection,
          page_web_type: data.ctx.$device.isMobileOrTablet ? 'responsive' : 'notresponsive'
        }
        return eventList
      }
    }

    const objSchema = this.getTrackData()
    const ctx = this.ctx

    try {
      const trackData = (events[type] || events.default)({ objSchema, payload, ctx })
      this.sendTrack(this.deleteNulls(trackData))
    } catch (error) {
      console.log('Error Analytics type: ' + type + ' Error', error)
    }
  }

  deleteNulls = (object) => {
    const self = this
    Object.keys(object).forEach(function (key) {
      if (object[key] == null || object[key] === '') {
        delete object[key]
      }
      if (typeof object[key] === 'object') {
        object[key] = self.deleteNulls(object[key])
        if (Object.keys(object[key]).length == 0) {
          delete object[key]
        }
      }
    })
    return object
  }

  sendTrack = (trackData) => {
    window.dataLayer?.push(trackData)
  }
}

export default (ctx, inject) => {
  inject('EventsGA4', new EventsGA4(ctx))
}
